import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import I18n from 'I18n';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage, FormattedHTMLMessage, FormattedJSXMessage } from 'LearningCenterUI/components/I18n';
import UILink from 'UIComponents/link/UILink';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner'; //@ts-expect-error Could not find declaration file for module

import upworkLogoUrl from 'bender-url!../../../../images/logo-upwork.png'; //@ts-expect-error Could not find declaration file for module

import { isTrackAwardAddedToUpwork } from '../../../selectors/appSelectors'; //@ts-expect-error Could not find declaration file for module

import { sendToUpwork } from '../../../actions/AppActions';
import { useCallback } from 'react';
import UIImage from 'UIComponents/image/UIImage';
import UIFlex from 'UIComponents/layout/UIFlex';
import { useTrack } from '../../tracks';
import UsageTracker from '../../../utils/UsageTracker';
import { useAwardByTrackId } from '../../awards';
export const SendToUpwork = ({
  trackId
}) => {
  const dispatch = useDispatch();
  const {
    track
  } = useTrack(trackId);
  const award = useAwardByTrackId(trackId);
  const isAwardAddedToUpwork = useSelector(state => isTrackAwardAddedToUpwork(state, trackId));
  const sendToUpworkHasError = useSelector(state => state.app.sendToUpworkHasError);
  const sendToUpworkIsRequesting = useSelector(state => state.app.sendToUpworkIsRequesting);
  const onAddToUpwork = useCallback(() => {
    dispatch(sendToUpwork(trackId));
    UsageTracker.track('awardInteraction', {
      action: 'send-to-upwork',
      trackId: trackId.toString(),
      trackName: track && track.name,
      awardName: award && award.awardName
    });
  }, [award, dispatch, track, trackId]);
  const stepTwoTranslation = isAwardAddedToUpwork ? 'learningCenter.upwork.addToUpworkStepTwoSent_jsx' : sendToUpworkHasError ? 'learningCenter.upwork.addToUpworkStepTwoError_jsx' : 'learningCenter.upwork.addToUpworkStepTwo_jsx';
  return /*#__PURE__*/_jsxs(UIFlex, {
    direction: "row",
    children: [/*#__PURE__*/_jsx(UIFlex, {
      justify: "center",
      style: {
        width: 195,
        flexGrow: 0
      },
      children: /*#__PURE__*/_jsx(UIImage, {
        src: upworkLogoUrl
      })
    }), /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.upwork.gotUpwork"
        })
      }), /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "learningCenter.upwork.addToUpworkStepOne"
        })
      }), sendToUpworkIsRequesting ? /*#__PURE__*/_jsx(UILoadingSpinner, {
        label: I18n.text('learningCenter.upwork.addToUpworkStepTwoSending'),
        showLabel: true,
        size: "xs",
        style: {
          margin: 0
        }
      }) : /*#__PURE__*/_jsx(FormattedJSXMessage, {
        elements: {
          Link: UILink
        },
        message: stepTwoTranslation,
        options: {
          onClick: onAddToUpwork
        }
      })]
    })]
  });
};